import { useEffect, useState } from 'react'

export function useLocalStorageState<T>(
  key: string,
  initialValue: T,
  options?: {
    deserialize?: (raw: string) => T
    serialize?: (value: T) => string
  },
) {
  const deserialize = options?.deserialize ?? ((raw: string) => JSON.parse(raw) as T)
  const serialize = options?.serialize ?? ((value: T) => JSON.stringify(value))

  const [state, setState] = useState<T>(() => {
    if (typeof window === 'undefined') return initialValue

    const raw = window.localStorage.getItem(key)
    if (raw === null) return initialValue

    try {
      return deserialize(raw)
    } catch {
      return initialValue
    }
  })

  useEffect(() => {
    if (typeof window === 'undefined') return

    window.localStorage.setItem(key, serialize(state))
  }, [key, serialize, state])

  return [state, setState] as const
}
